"use client";

import { strings } from "@perceptron/constants";

import ClearButton from "@demo/components/PromptControls/ClearButton";
import RunButton from "@demo/components/PromptControls/RunButton";
import { clearDetections, runDetect, stopDetect } from "@demo/libs/detect";
import { useDetectStore } from "@demo/store/detect";

import DetectSettings from "./DetectSettings";

/**
 * Detect's footer: a Cleanup control, run settings (output switcher + Think),
 * and Run. Built on the shared `PromptControls`; `RunButton` toggles to Stop
 * (aborting the request) while a detection is running. Run settings collapse
 * into a Settings popover on mobile. Mirrors the Compose footer pattern.
 */
const DetectFooter = () => {
  const image = useDetectStore((state) => state.image);
  const categories = useDetectStore((state) => state.categories);
  const status = useDetectStore((state) => state.status);
  const resetDetect = useDetectStore((state) => state.resetDetect);

  const isRunning = status === "running";
  const isReadyToRun = !!image && !isRunning;
  const hasAnything = !!image || categories.length > 0;

  const handleClear = () => {
    resetDetect();
    clearDetections();
  };

  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="flex items-center gap-1">
        <DetectSettings />

        <ClearButton
          className="rounded-full bg-background-alt-2 p-3 sm:bg-transparent"
          disabled={!hasAnything || isRunning}
          tooltip={strings.detect.cleanupTooltip}
          onClear={handleClear}
        />
      </div>

      <RunButton
        disabled={!isReadyToRun && !isRunning}
        isStreaming={isRunning}
        runLabel={strings.promptView.buttons.run}
        stopLabel={strings.promptView.buttons.stop}
        onRun={() => runDetect()}
        onStop={() => stopDetect()}
      />
    </div>
  );
};

export default DetectFooter;
